module.exports = __webpack_public_path__ + "img/dot.9b1513e0.svg";